import AndrewJoseph from '../../assets/andrew-joseph.png';


export const sampleUsers = {
  users: [
    {
      uid: "1",
      name: "Admin profile",
      avatar: AndrewJoseph,
    },
  ],
};
